import { getSimpleAxiosInstance } from "@/plugins/axios";

export async function getAllPublicationsTypes() {
  return getSimpleAxiosInstance().post("/lovs/filtered/", {
    value_type: "publications",
  });
}
